import styled from 'styled-components';

export default styled.section`
  padding: 2.625rem ${props => props.theme.padding.inner} 0;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 2.9375rem ${props => props.theme.padding.inner} 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 3.0625rem ${props => props.theme.padding.inner} 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    .isAnimated& {
      opacity: 0;
      transition: all 0.4s ease-in-out;
      transition-delay: 0.4s;
    }
  }

  .active& {
    opacity: 1;
  }

  .inner {
    position: relative;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    margin: auto;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .thumbnail,
  .data {
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      width: 50%;
    }
  }

  .thumbnail {
    position: relative;
    box-sizing: border-box;
    z-index: 10;
    cursor: pointer;

    picture {
      display: inline-block;
      width: 100%;
      height: 0;
      padding-top: 61.5%;
      position: relative;

      img {
        border-radius: 4px;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .data {
    padding-top: 2.5rem;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      padding-top: 0;
      padding-left: 2.125rem;
    }

    .category {
      margin: 0;
    }

    .title {
      display: inline-block;
      margin: 0.625rem 0 0;
      text-decoration: none;
      color: ${props => props.theme.colors.claytonBlue};

      &::after {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .excerpt {
      margin: 0.75rem 0 0.75rem;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        margin: 0.75rem 0 1.8125rem;
      }
    }

    a.type-p {
      font-size: ${props => props.theme.type.paragraph.default};
      line-height: ${props => props.theme.lineHeights.paragraph.default};
      letter-spacing: ${props => props.theme.letterSpacing.paragraph};
      font-weight: 600;
    }
  }
`;
